export const RESET = 'mediaPageComponent.reset'
export const SET_FILE = 'mediaPageComponent.setFile'
export const SET_ERROR = 'mediaPageComponent.setError'
export const SET_IS_UPLOADING = 'mediaPageComponent.setIsUploading'
export const SET_IS_LOADING = 'mediaPageComponent.setIsLoading'
export const SET_IS_SAVING_LINK = 'mediaPageComponent.setIsSavingLink'
export const SET_LINK_URL = 'mediaPageComponent.setLinkUrl'
export const SET_LINK_NAME = 'mediaPageComponent.setLinkName'
export const SET_IS_LINK_URL_VALID = 'mediaPageComponent.setIsLinkUrlValid'

export function setFile(payload: File) {
  return {
    type: SET_FILE,
    payload
  } as const
}

export function reset() {
  return {
    type: RESET,
    payload: {}
  } as const
}

export function setError(payload: string) {
  return {
    type: SET_ERROR,
    payload
  } as const
}

export function setIsUploading(payload: boolean) {
  return {
    type: SET_IS_UPLOADING,
    payload
  } as const
}

export function setIsSavingLink(payload: boolean) {
  return {
    type: SET_IS_SAVING_LINK,
    payload
  } as const
}

export function setIsLoading(payload: boolean) {
  return {
    type: SET_IS_LOADING,
    payload
  } as const
}

export function setLinkUrl(payload: string) {
  return {
    type: SET_LINK_URL,
    payload
  } as const
}

export function setLinkName(payload: string) {
  return {
    type: SET_LINK_NAME,
    payload
  } as const
}

export function setIsLinkUrlValid(payload: boolean) {
  return {
    type: SET_IS_LINK_URL_VALID,
    payload
  } as const
}

export type MediaPageAction = ReturnType<
  | typeof setFile
  | typeof reset
  | typeof setError
  | typeof setIsUploading
  | typeof setIsLoading
  | typeof setLinkUrl
  | typeof setLinkName
  | typeof setIsLinkUrlValid
  | typeof setIsSavingLink
>
